'use strict';

export default class YourFinesList {
	

	constructor() {
			//global variable
			var originalResult = [];

			var currentResult = [];


			if($('#notificationSettings').length > 0){
			var $setting;
			$('#no').on('click', function() { none() })
			$('#mobile').on('click', function() { mobile() })
			$('#email').on('click', function() { email() })
			$('#both').on('click', function() { both() })

			function both(){
				$("input").prop('required',true);
				$('.email-field, .mobile-field').css('display', 'block');
			    if ($('.message').text('') != '') { $('.message').text(''); }
			}

			function none(){
				$("input").prop('required',false);
				$('.email-field, .mobile-field').css('display', 'none');
			    if ($('.message').text('') != '') { $('.message').text(''); }
			}

			function email(){
			    $("#email-field").prop('required',true);
			    $("#mobile-field").prop('required',false);
				$('.email-field').css('display', 'block');
			    $('.mobile-field').css('display', 'none');
				if ($('.message').text('') != '') { $('.message').text(''); }
			}

			function mobile(){
				$("#email-field").prop('required',false);
				$("#mobile-field").prop('required',true);
				$('.email-field').css('display', 'none');
				$('.mobile-field').css('display', 'block');
				if ($('.message').text('') != '') { $('.message').text(''); }
			}

			var $DebtorID ='',
				 	$email = '',
				   $mobile ='';

			$.ajax({  // LOAD THE USER'S DATA IN THE REMINDER FORM
					  method: "POST",
					  url: window.location.origin + $('#notificationSettings').data('reminder-url'),
					  success:function( data ){
							var $email = data.IsSubscribedEM,
								$SMS = data.IsSubscribedSMS;

								$('#email-field').val(data.Email);
								$('#mobile-field').val(data.Mobile);

							if (($email == true) & ($SMS == true)){
								$('#both').attr('checked','checked');
								both();
							} else if ($email == true){
								$('#email').attr('checked','checked');
								email();
							} else if ($SMS == true){
								$('#mobile').attr('checked','checked');
								mobile();
							} else {
								$('#no').attr('checked','checked');
								none();
							}

							$DebtorID = data.DebtorID;
							   $email = data.Email;
							  $mobile = data.Mobile;

							return $email;
							return $mobile;
					  }
				});

				$('#notificationSettings').on('submit',function(e){
					
					// UPDATE THE REMINDER DETAILS
					var reminderData = {};

					if ( $('#both').is(":checked") ){
						
						reminderData = {'DebtorID': $DebtorID,'Email': $('#email-field').val(),'Mobile': $('#mobile-field').val(),'IsSubscribedEM':true ,'IsSubscribedSMS':true};
					} else if ( $('#email').is(":checked") ){
						
						reminderData = {'DebtorID': $DebtorID,'Email': $('#email-field').val(),'Mobile': null,'IsSubscribedEM':true ,'IsSubscribedSMS':false};
						$("#mobile-field").val("");
					} else if ( $('#mobile').is(":checked") ){
						
						reminderData = {'DebtorID': $DebtorID,'Email': null,'Mobile': $('#mobile-field').val(),'IsSubscribedEM':false ,'IsSubscribedSMS':true};
						$("#email-field").val("");
					} else if ($('#no').is(":checked")){
						
						reminderData = {'DebtorID': $DebtorID,'Email': null,'Mobile': null,'IsSubscribedEM':false ,'IsSubscribedSMS':false};
						$("#email-field").val("");
						$("#mobile-field").val("");
					}

					$.ajax({
						  url: window.location.origin + $('#notificationSettings').data('update-url'),
						  type: 'PUT',
						  data: reminderData,
						  success: function() {
							    //location.href;
								$('.message').text('Your notification preference has been saved.');
								
						  }
					});
					e.preventDefault();
				})

		}
		if ($('.fine-details').length > 0){

			//Saved form link from details page

			function getUrlVars(){
			    var vars = [], hash;
			    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			    for(var i = 0; i < hashes.length; i++)
			    {
			        hash = hashes[i].split('=');
			        vars.push(hash[0]);
			        vars[hash[0]] = hash[1];
			    }
			    return vars;
			}

			var obNo = getUrlVars()["obligation"];

			$.ajax({ // GET all saved forms and put them into a list
				method: "GET",
				url: window.location.origin  + $('.notice').data('notice-url') + '?obligation=' + obNo,
   				contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
				success:function( data ){
					
					if ( data.length > 0){
						var notification = data[0].Reminder.ExistingReminder
						var text = "";

						if(!notification){
							text = "Reminder notifications are disabled";
						} else {
							text = "Reminder notifications are enabled";
						}
					}
					
				 if ( data.length > 1){
					 if(data[0].IsCompany===true){
						$('.notice').addClass('multiple')
				  		$('.notice').append( '<ul class="accordion">' +
                      					'<li>' +
											'<div href="javascript:void(0)" class="head">'+
												'<img src="/Assets/images/Icon_exclamation.svg" class="exclamation">'+
												'<span class="active" style="width:550px">' +
	                            					'<p>You have added this fine to multiple saved applications. </p>' +
													'<p>Choose a form to complete.</p>'+
													'<p>'+ text +'<span> <a href="edit-notification" style="min-width:auto">Update</a></span></p></span>'+'<span class="icon-accordion-toggle" href="javascript:void(0)" title="Expand and close"><span class="sr-only"> Open / Close </span></span>'+
											'</div>'+
					                        '<div class="body">'+
					                          '<ul></ul>'+
					                        '</div>'+
					                      '</li>'+
										'</ul>')
						$('.page-container').append(`<div class="confirm-message">
						<div class="confirm-content">
							<h4>Are you sure about deleting this saved form?</h4>
							<div class="modal-nav"><a href="#" class="btn included-fines confirm-delete">Delete</a>
							<p><a id="return" href="#">Go back to Your fines</a></p>
							</div>
						</div>
						<div class="fade"></div>
						</div>`);

				  		for (var i = 0; i < data.length; i++){
							var fine = data[i];
							var deleteBTN = '<a href="javascript:void(0)" data-id="'+fine.PartialFormID+'" class="btn btn-outline btn-delete">Delete</a>';
							var resumeBTN = '<a href="'+ window.location.origin + "/" + data[i].PartialFormURI +'" class="btn">Resume</a>';
						  $('.notice .body ul').append(' <li><span>'+  fine.FormType +'</span><div class="btngroup">'+ deleteBTN + resumeBTN +'</div></li>')
					  	}
						
						$('.notice .body').slideUp();
						$('.notice').show();

						// delete this saved form
					function deleteForm(deleteID,listItem){

						$.ajax({
							method: "DELETE",
							url: window.location.origin  + "/api/sitecore/PartialForms/DeleteFromDB" + '?' + $.param({"PartialFormId": deleteID}),
							success:function( data ){
								listItem.remove();
								if($('ul#StartedFineList li').length < 1){
									$('.content-holder.application-list').next('.content-header').addClass('first');
									$('.application-list').css("display","none");
								}
							}
						});
					}

					var deleteID;
					var listItem;
					
				  $('.btn-delete').on('click',function(){

					   deleteID = $(this).data('id');
					   listItem = $(this).parents(':eq(5)');
						 $('.confirm-message').css("display","block");

				  })
					
					$('.confirm-delete').on('click',function(){
					  // delete the saved form with this PartialFormId
					  	deleteForm(deleteID, listItem);
						$('.confirm-message').css("display", "none");
						location.reload();

					})

					$('#return').on('click',function(){
					  // delete the saved form with this PartialFormId
						$('.confirm-message').css("display","none");
					})
						
					 }else{
						$('.notice').addClass('multiple')
				  		$('.notice').append( '<ul class="accordion">' +
                      					'<li>' +
											'<div href="javascript:void(0)" class="head">'+
												'<img src="/Assets/images/Icon_exclamation.svg" class="exclamation">'+
												'<span class="active">' +
	                            					'<p>You have added this fine to multiple saved applications. </p>' +
	                            					'<p>Choose a form to complete.</p></span><span class="icon-accordion-toggle" href="javascript:void(0)" title="Expand and close"><span class="sr-only"> Open / Close </span>'+
												'</span>'+
											'</div>'+
					                        '<div class="body">'+
					                          '<ul></ul>'+
					                        '</div>'+
					                      '</li>'+
					                    '</ul>')

				  		for (var i = 0; i < data.length; i++){
							var fine = data[i]
						  $('.notice .body ul').append(' <li><span>'+  fine.FormType +'</span><a href="'+ window.location.origin + "/" + fine.PartialFormURI +'" class="btn">Resume</a></li>')
					  	}
						
						$('.notice .body').slideUp();
						$('.notice').show();
					 }
				  
					} else if ( data.length > 0 && data[0].IsCompany === false) {
						$('.notice').append('<div class="notice-msg">'+
												'<p><span><img src="/Assets/images/Icon_exclamation.svg" class="exclamation"></span> This fine is a part of an uncompleted ' + data[0].FormType +' form. </p>'+
												'<a href="' + window.location.origin + "/" + data[0].PartialFormURI +'" class="btn">Resume</a>'+
											'</div>')
						$('.notice').show();
					} else if (data.length > 0){
						
						var fine = data[0];
						var deleteBTN = '<a href="javascript:void(0)" data-id="'+fine.PartialFormID+'" class="btn btn-outline btn-delete">Delete</a>';
						var resumeBTN = '<a href="'+ window.location.origin + "/" + data[0].PartialFormURI +'" class="btn">Resume</a>';
						$('.notice').append(`<div data-notice-url="/api/sitecore/PartialForms/GetPartialFormInFineDetail" class="content-header first notice">
						<div class="notice-msg"><img src="/Assets/images/Icon_exclamation.svg" class="exclamation">
						  <div class="txtgroup"> 
							<p>This fine is a part of an uncompleted ` + data[0].FormType + ` form.</p>
							<p class="notice-edit notification-mgs">
							  `+text+`<span> <a href="edit-notification" style="min-width:auto">Update</a></span>
							</p>
						  </div>
						  <div class="btngroup">`+ deleteBTN + resumeBTN +`</div>
						</div>
					  </div>`);
					  $('.page-container').append(`<div class="confirm-message">
					  <div class="confirm-content">
						<h4>Are you sure about deleting this saved form?</h4>
						<div class="modal-nav"><a href="#" class="btn included-fines confirm-delete">Delete</a>
						  <p><a id="return" href="#">Go back to Your fines</a></p>
						</div>
					  </div>
					  <div class="fade"></div>
					</div>`);
					  $('.notice').show();
					  // delete this saved form
					function deleteForm(deleteID,listItem){

						$.ajax({
							method: "DELETE",
							url: window.location.origin  + "/api/sitecore/PartialForms/DeleteFromDB" + '?' + $.param({"PartialFormId": deleteID}),
							success:function( data ){
								listItem.remove();
								if($('ul#StartedFineList li').length < 1){
									$('.content-holder.application-list').next('.content-header').addClass('first');
									$('.application-list').css("display","none");
								}
							}
						});
					}

					var deleteID;
					var listItem;
					
				  $('.btn-delete').on('click',function(){

					   deleteID = $(this).data('id');
					   listItem = $(this).parents(':eq(5)');
						 $('.confirm-message').css("display","block");

				  })
					
					$('.confirm-delete').on('click',function(){
					  // delete the saved form with this PartialFormId
					  	deleteForm(deleteID, listItem);
						$('.confirm-message').css("display", "none");
						location.reload();

					})

					$('#return').on('click',function(){
					  // delete the saved form with this PartialFormId
						$('.confirm-message').css("display","none");
					})
					}	

					
				
				}
			})

			$('.notice').on('click','.accordion',function(){
				var $isopen = $(this).find('li').hasClass('active')

				if ( $isopen == false){
					$('.notice .body').slideDown();
				} else {
					$('.notice .body').slideUp();
				}

				$(this).find('li').toggleClass('active');
			})
		}
		if ($('.your-fines-list').length > 0){
			//New started application list API
			$.ajax({ // GET all saved forms and put them into a list
				method: "POST",
				url: window.location.origin  + $('#StartedFineList').data('your-saved-url'),
				success:function( data ){
					var notification = data.Reminder.ExistingReminder
					var text = $('.notification-mgs .msg').data('enabled');

					if(!notification){
						text = $('.notification-mgs .msg').data('disabled');
						$('.notification-mgs .msg').text(text);
					} else {
						text = $('.notification-mgs .msg').data('enabled');
						$('.notification-mgs .msg').text(text);
					}


					// remove loader spinner on API call success

				  $('#StartedFineList').html('');

				  // varible to hide list item 5 and above
				  var isHidden = "";
					if(data.FormList.length > 0){
						for(var i = 0; i < data.FormList.length; i++){
						  // Hide the 5th form onwards
						  if(i > 4){ isHidden = "display:none"; }
						  var fine = data.FormList[i];
						  var formURL = window.location.origin + "/" + fine.PartialFormURI ;

						  var deleteBTN = '<a href="javascript:void(0)" data-id="'+fine.PartialFormId+'" class="btn btn-outline btn-delete">Delete</a>'
						  var resumeBTN = '<a href="'+formURL+'" class="btn">Resume</a>'

						  // Loop through each form and append it to the saved form list
						  var htmlToInsert = '<li style="'+ isHidden +'">'+
												  '<a href="javascript:void(0)" class="head">' +
													  '<span>'+ fine.ApplicationType +'</span>'+
													  '<span class="icon-accordion-toggle" href="javascript:void(0)" title="Expand and close"><span class="sr-only"> Open / Close </span></span>'+
												  '</a>'+
												  '<div class="body">'+
												  '<table>'+
													  '<tbody>'+
														  '<tr>'+
															  '<td><label> Start date </label><span>'+ fine.StartDate +'</span></td>'+
															  '<td><label> Expiry date </label><span>'+ fine.ExpiryDate +'</span></td>'+
															  '<td><label> #No. of obligations </label><span style="font-weight:bold">'+ fine.NumberOfObligtaions +'</span></td>'+
															  '<td>' + deleteBTN + resumeBTN + '</td>'
														  '</tr>'+
													  '</tbody>'+
												  '</table>'+
												'</div>'+
											  '</li>'

						  $('#StartedFineList').append(htmlToInsert);

						  if (data.length > 5) {
							  // If there are more than 5 saved forms, add the show all btn
							  $('#StartedFineList').after(`
								  <div class="note showall">
									  <a href="javascript:void(0)" class="ShowAllFines" data-content-hidden="true">
										  Show all <span class="bold TotalFines">${section.length}</span>
										  <span class="fineType"> payment arrangements</span>
									  </a>
								  </div>
							  `);
						  }
						  $("#StartedFineList").css("borderBottom", "1px solid #ddd");
					  }
					}else {
						$('.content-holder.application-list').next('.content-header').addClass('first');
						$('.application-list').css("display","none");
					}


					var deleteID;
					var listItem;
				  $('.btn-delete').on('click',function(){

					   deleteID = $(this).data('id');
					   listItem = $(this).parents(':eq(5)');
						 $('.confirm-message').css("display","block");

				  })
				  
					
					$('.confirm-delete').on('click',function(){
					  // delete the saved form with this PartialFormId
					  deleteForm(deleteID, listItem);
						$('.confirm-message').css("display","none");
						

					})

					$('#return').on('click',function(){
					  // delete the saved form with this PartialFormId
						$('.confirm-message').css("display","none");
					})
					  // class to hide empty expiry dates on mobile
					  $('#StartedFineList span:empty').parent('td').addClass('desktop-only');
				}
			});

			// delete this saved form
			function deleteForm(deleteID,listItem){

				$.ajax({
					method: "DELETE",
					url: window.location.origin  + $('#StartedFineList').data('your-delete-url') + '?' + $.param({"PartialFormId": deleteID}),
					success:function( data ){
						listItem.remove();
						if($('ul#StartedFineList li').length < 1){
							$('.content-holder.application-list').next('.content-header').addClass('first');
							$('.application-list').css("display","none");
						}
					}
				});
			}

			// ORGINAL CODE
			var target = window.location.origin + $('.your-fines-list').data('your-fines-url');
			
			$.ajax({
					  method: "POST",
					  url: target,
					  success:function( Result ){
							if (Result.OutstandingFines == "" || typeof Result.OutstandingFines == "undefined" || Result.OutstandingFines == null){
								var err = new Error('Fineslist OutstandingFines is blank');
								newrelic.noticeError(err);
							}
							
							originalResult = Result;
							currentResult = Result;
							displayOutstandingFines(Result.OutstandingFines);
					  		displayPaymentArrangements(Result.PaymentArrangements);
					  		displayClosedFines(Result.ClosedFines);
							displayTotalOutstanding(Result);
					  		attachShowListeners();
					  },
					  error: function(xhr, ajaxOptions, thrownError) {

							var json = {};
							try
							{
								json = $.parseJSON(xhr.responseText);
							}
							catch(err){
								//was not passed back valid Json, we will just display a generic error message in this case.
							}

							$('#FinesListError').html(json.Error || "Something went wrong while processing the request.");
					}
				});

			function displayTotalOutstanding(section){
				var $wrapper = $('.wrapper.fines');
				var TotalArrangementDue = 0.00;

				$.each(section.PaymentArrangements, function(index, value){
					TotalArrangementDue = (value.TotalAmountDue * 100 + TotalArrangementDue *100) / 100;
				});

				var totaldue = ((section.OutstandingFines.TotalAmountDue * 100 + TotalArrangementDue * 100) / 100).toFixed(2);

				totaldue = Number(totaldue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
				if(section.OutstandingFines.WarrantCosts > 0){
					$wrapper.append('<div class="content-header yourtotal">' + '<h4>Total outstanding fines   <br> <span style="margin-left: 2px; margin-top: 0px; font-size: 15px; font-weight: 300;">Including outstanding warrant costs</span></h4><h4 id="totalamount">' + '$' + totaldue + '</h4>\n\t\t\t\t\t</div>');
				}else {
					$wrapper.append('<div class="content-header yourtotal">' + '<h4 style="margin-bottom: 12px;">Total outstanding fines  </h4><h4 id="totalamount"  style="padding-top: 0;">' + '$' + totaldue + '</h4>\n\t\t\t\t\t</div>');
				}
			}

			function attachShowListeners() {
				$('.ShowAllFines').on('click', function()
				{
					var isHidden = String($(this).data('content-hidden'));
					var fineType = $(this).find('.fineType').html();
					var fineCount = parseInt($(this).find('.TotalFines').html());
					var listItems = "";
					if(fineType == " outstanding fines"){		
						listItems = $(this).parent().siblings('#outstandingFineContent').find('li');	
					}else{	
						listItems = $(this).parent().prev('.content-holder').find('li');	
					}
					if(isHidden == 'true')
					{
						//get the amount of fines that will be hidden when clicked again
						fineCount -= 5;

						//show all items in list
						listItems.show();
						$("#outstandingFineContent").css("border-bottom", "1px solid #ddd");
						listItems.removeClass();
						$(this).html('Hide <span class="bold TotalFines">'+fineCount+'</span><span class="fineType">'+fineType+'</span>');

						if ($(this).parent().prev('.content-holder').hasClass('arrangement-holder')){

							$('.arrangement-holder ul.fines-table > li:nth-child(5)').css('border-bottom','1px solid #ddd');
						}

					 	$(this).data('content-hidden','false');
					}
					else
					{
						//get the total number of fines in the section
						fineCount += 5;
						//hide all elements in the list
						listItems.hide();
						$("#outstandingFineContent").css("border-bottom", "0px");
						//show first 5 items in the list
						listItems.slice(0,5).show();
						listItems.slice(6).addClass("hidden");
						if ($(this).parent().prev('.content-holder').hasClass('arrangement-holder')){

							$('.arrangement-holder ul.fines-table > li:nth-child(5)').css('border-bottom','none');
						}

						$(this).html('Show all <span class="bold TotalFines">'+fineCount+'</span><span class="fineType">'+fineType+'</span>');

					 	$(this).data('content-hidden','true');

					}
				});
				$('#help-whatAreWarrantCost').on('click', function () {	
					$('#warrantCostModal').css('display', 'block');	
				});	
				$('.help-whatAreWarrantCostPA').on('click', function () {	
					$('#warrantCostModal').css('display', 'block');	
					return false;
				});
				$('.OffenceImageFineList').on('click', function (event) {
					ga('send', 'event', 'View Image', 'Photo clicked under outstanding fines', 'Photo button', event.currentTarget.dataset['id']);
				});
				$('.OffenceImageClosedFineList').on('click', function (event) {
					ga('send', 'event', 'View Image', 'Photo clicked under closed fines', 'Photo button', event.currentTarget.dataset['id']);
				});
			};

			//a flag for indicating if a column has been sorted , true if yes , false otherwise
			var currentSortedOustanding = "";

			var currentSortedPaymentArrangement = [];


			$(document).on('click','.fines-list-sort-button',function(){
				
				var parentId = $(this).parent().attr('id');
				
				//when it comes to payment arrangement table, the index should be there to distinguish one or more table.
				var arrangementIndex = $(this).parent().data('index') === 'undefined'?-1:$(this).parent().data('index');

				var tableTargeted = $('[data-table="'+parentId+'"]');
				var property = $(this).data('property');
				var info = $(this).data('info');
				var order = $(this).data('order');

				
				flipAndResetSortIcon(tableTargeted,$(this));
				
				//reset every column
				tableTargeted.siblings('table').find('.fines-list-sort-button').data('order','asc');
				//flip it
				if(order == 'asc'){
					$(this).data('order','desc');
					
				}else{
					$(this).data('order','asc');
				}

				tableTargeted.siblings('table').find('.fines-list-sort-button').removeClass('active');
				$(this).addClass('active');


				sortTable(parentId, property,order,'desktop', info, arrangementIndex);
			});


			$(document).on('click','.fines-list-sort-order-btn,.fines-list-sort-data-btn',function(){

				var sortParent = $(this).closest('.fines-list-sort-mobile');
				if($(this).hasClass('fines-list-sort-order-btn')){
					//if the order button is clicked
					sortParent.find('.fines-list-sort-order-btn').removeClass('active');
					
				}
				var arrangementIndex = $(this).closest('.fines-list-sort-mobile').data('index') === 'undefined'?-1:$(this).closest('.fines-list-sort-mobile').data('index');
				if($(this).hasClass('fines-list-sort-data-btn')){
					// if the property button is being sorted
					sortParent.find('.fines-list-sort-data-btn').removeClass('active');
					if($(".fines-list-sort-order-btn.active").length <=0 ){
						sortParent.find('.fines-list-sort-order-btn[data-order="asc"]').addClass('active');
					}
					
				}

				$(this).addClass('active');

				var order = sortParent.find('.fines-list-sort-order-btn.active').data('order');

				var data = sortParent.find('.fines-list-sort-data-btn.active').data('property');

				var table = sortParent.find(this).closest('.fines-list-sort-mobile').data('table');

				var info = sortParent.find('.fines-list-sort-data-btn.active').data('info');
				
				
				
				if(data !== 'undefined' && table !== 'undefined' ){
					sortTable(table,data,order,'mobile',info, arrangementIndex);
				}

			});

			
			$(document).on('click','.fines-list-sort-info-btn',function(e){
				
				$(this).closest('.fines-list-sort-mobile').find('.fines-list-sort-slide').slideToggle();
				var buttonText = $(this).text();
				
				if(buttonText.toLowerCase() == "change order"){
					$(this).text('Close');
					
				}else{
					$(this).text('Change Order');
				}
			});

			function flipAndResetSortIcon(table, column){
				//reset the arrow but the column with the property
				
				var allColumnButThis = $('#'+table.data('table')+' .fines-list-sort-button').not(column);
				
				allColumnButThis.find('i').removeClass().addClass('icon-sort-no-arrow');
				//by default it is desending,
				//the arrow is flipped , that what these lines of code in the nutshell
				
				if(column.find('i').hasClass('icon-sort-arrow') || column.find('i').hasClass('icon-sort-no-arrow') ){
					column.find('i').removeClass().addClass('icon-sort-arrow-flip');
					table.find('.order-data-text-information').find('i').removeClass().addClass('icon-sort-arrow-flip');
				}else if(column.find('i').hasClass('icon-sort-arrow-flip')){
					column.find('i').removeClass().addClass('icon-sort-arrow');
					table.find('.order-data-text-information').find('i').removeClass().addClass('icon-sort-arrow');
				}

			}
			//function to sort the table out
			function sortTable(table, property, order ='asc', view ='desktop',info ='', paymentArrangementIndex = -1) {
				
				var tableTargeted = $('[data-table="'+table+'"]');
				if(info != ''){
					
					var paragraph = tableTargeted.find('.order-data-text-information');
					
					var arrow = order=='asc'?'icon-sort-arrow-flip':'icon-sort-arrow';

					paragraph.html('<i class="'+arrow+'"></i><b>Ordered by '+info+'</b>');
				}
				//data-property must be the same for the mobile and desktop view button.
				if(view == 'desktop'){
					//syncronise the mobile view
					tableTargeted.find('.fines-list-sort-data-btn').removeClass('active');
					tableTargeted.find('.fines-list-sort-data-btn[data-property="'+property+'"]').addClass('active');
					tableTargeted.find('.fines-list-sort-order-btn').removeClass('active');
					tableTargeted.find('.fines-list-sort-order-btn[data-order="'+order+'"]').addClass('active');
					
				}else{
					
					//syncronise the desktop view
					tableTargeted.siblings('table').find('.fines-list-sort-button').removeClass('active');
					var targetedColumn = tableTargeted.siblings('table').find('.fines-list-sort-button[data-property="'+property+'"]');
					var arrowTable = order=='asc'?'icon-sort-arrow-flip':'icon-sort-arrow';

					tableTargeted.siblings('table').find('.fines-list-sort-button').removeClass('active');
					targetedColumn.addClass('active');

					tableTargeted.siblings('table').find('.fines-list-sort-button').find('i').removeClass().addClass('icon-sort-no-arrow');

					targetedColumn.find('i').removeClass();

					targetedColumn.find('i').addClass(arrowTable);
					//reset every column
					tableTargeted.siblings('table').find('.fines-list-sort-button').data('order','asc');

					targetedColumn.data('order',order);
					

				}
				
				

				if(
					//top one for payment arrangement table and bottom one for the outstanding payment table
					(
						(paymentArrangementIndex >= 0 && property == currentSortedPaymentArrangement[paymentArrangementIndex]) ||
						(table == 'outstanding-table' && property == currentSortedOustanding)
					)
					&& view == 'desktop'){
					//if the column is already sorted then we just need to reverse it.
						
					if(table == 'outstanding-table'){
						currentResult.OutstandingFines.Obligations = currentResult.OutstandingFines.Obligations.reverse();
					}else if(paymentArrangementIndex >= 0){
						//now going into the payment arrangement table
						currentResult.PaymentArrangements[paymentArrangementIndex].Obligations = currentResult.PaymentArrangements[paymentArrangementIndex].Obligations.reverse();
					}
				}else{
					//by default the column will be sorted on ascending order.	
					var sortFunction = (a, b) => {
						var bandA = a[property];
						var bandB = b[property];
						
						
						
						//check if this is a date
						if(property == "DueDate"){
							bandA = Date.parse(a[property]);
							bandB = Date.parse(b[property]);

							if (Number.isNaN(bandA)){
								bandA = -1;
							}
							if (Number.isNaN(bandB)){
								bandB = -1;
							}
							
						}else if(typeof a[property] == "string" && typeof b[property] == "string"){
							bandA = a[property].toUpperCase();
							bandB = b[property].toUpperCase();
						}

						
						
						var comparison = 0;
						if(order =='asc') {
							if (bandA >= bandB) {
								comparison = 1;
							} else if (bandA < bandB) {
								comparison = -1;
							}
						}else{
							if (bandA <= bandB) {
								comparison = 1;
							} else if (bandA > bandB) {
								comparison = -1;
							}
						}
							
						return comparison;
					}
					
					if(table == 'outstanding-table'){
						currentSortedOustanding = property;
						currentResult.OutstandingFines.Obligations = currentResult.OutstandingFines.Obligations.sort(sortFunction);
					}else if(paymentArrangementIndex != -1){
						//now going into the payment arrangement table
						
						currentSortedPaymentArrangement[paymentArrangementIndex] = property;
						currentResult.PaymentArrangements[paymentArrangementIndex].Obligations = currentResult.PaymentArrangements[paymentArrangementIndex].Obligations.sort(sortFunction);
						
					}
				}
				if(table == 'outstanding-table'){
					displayOutstandingFines(currentResult.OutstandingFines);
				}else if(paymentArrangementIndex != -1){
					//now going into the payment arrangement table
					var sortedHtml = getSortedObligationsHTML(currentResult.PaymentArrangements[paymentArrangementIndex].Obligations, 
						currentResult.PaymentArrangements[paymentArrangementIndex].FinesDetailsUrl, 
						currentResult.PaymentArrangements[paymentArrangementIndex].PayYourFineUrl,
						tableTargeted
						);
					tableTargeted.siblings('ul.fines-table').html(sortedHtml);
				}
			}

			//get html for payment arrangement
			function getSortedObligationsHTML(obligations, FinesDetailsUrl, PayYourFineUrl,tableTargeted) {


				
				var currentLength = tableTargeted.siblings('ul.fines-table').find('li').not(':hidden').length;
					
				var isHidden = String(tableTargeted.parent().siblings('.showall').find('.ShowAllFines').data('content-hidden'));
					
				var fineCount = parseInt(tableTargeted.parent().siblings('.showall').find('.ShowAllFines').find('.TotalFines').html());
				
				
				if(isHidden == 'true')
				{
					//get the amount of fines that will be hidden when clicked again
					fineCount -= 5;	
				}
				else
				{
					//get the total number of fines in the section
					fineCount += 5;
				}
				
				var html = "";
				$.each(obligations, function(index, value) {
					var fineStateInfo =_getIconAndFineStateText2(value.FinesStage);
					html += `
						<li ${index > currentLength - 1 ? 'style="display:none"' : ''}>
							<a href="javascript:void(0)" class="head">
								<span>${value.ObligationNumber}</span>
								<span class="icon-accordion-toggle" href="javascript:void(0)" title="Expand and close">
									<span class="sr-only"> Open / Close </span>
								</span>
							</a>
							<div class="body">
								<table>
									<tbody><tr>
										<td><label> Fine stage </label><span class="${fineStateInfo.icon}">${fineStateInfo.state}</span></td>
										<td><label> Total amount </label><span class="bold">$${value.TotalFineAmount}</span></td>
										<td><label> Amount outstanding </label><span class="bold">$${value.AmountDue}</span></td>
										<td>
											<a href="${FinesDetailsUrl}?obligation=${value.Index}" class="btn btn-outline">View</a>
											<form action="${PayYourFineUrl}" method="post" style="display:inline">
												<input type="hidden" name="Identifier" value="${value.ObligationNumber}">
												<input type="hidden" name="currentPage" value="${window.location.href}">
												<button type="submit" class="btn btn-colored white">Pay</button>
											</form>
										</td>
									</tr>
								</tbody></table>
							</div>
						</li>
					`;
				});
				

				return html;
			}

			//display the overdue fines table
			function displayOutstandingFines(section){
				var summaryText = "";
				if (section.SummaryText)
				{		
					summaryText = section.SummaryText;
				}
				$('#OutstandingPlanFinesSummary').html(summaryText);
				$('#OutstandingFineList').html('');

				var alertBlock = "";
				var fineIcon = "";
				var fineState = "";
				var showAllFinesLink = false;
				if(section.Obligations.length > 5)
				{
					$('#ShowAllOutstanding .TotalFines').html(section.Obligations.length);
					showAllFinesLink = true;
				}
				$('#outstandingFineContent').css({"border-bottom": "none"});
				//if false, the data has been loaded initially
				//to syncronise the state of the table while sorting
				var isLoaded = String($('#ShowAllOutstanding .ShowAllFines').data('content-hidden'));
				for(var i = 0; i < section.Obligations.length; i++)
				{
					var isHidden = "";
					if(i > 4 && isLoaded == 'true')
					{
						isHidden = "display:none";
					}

					var fine = section.Obligations[i];


                    function parseDate(s) {
                        var b = s.split(/\D/);
                        return Date.UTC(b[2], --b[1], b[0]);
                    }



                    var dueDate = '<span class="due">' + fine.DueDate + '</span>';

                    var timeLeft = fine.DueDate;
                    timeLeft = parseDate(timeLeft);

                    var todayDate = new Date();
                    todayDate = parseDate(todayDate.getDate() + '/' + (todayDate.getMonth()+1) + '/' + todayDate.getFullYear());

					
                    if (fine.OnHold) {
                        alertBlock = '<span class="dueSoon">On Hold</span>';
                        dueDate = "";
                    } else {

                        if (timeLeft < todayDate) {
                            alertBlock = '<span class="dueSoon">Overdue</span>';
                            dueDate = "";
                        } else {
                            alertBlock = "";
                            if (timeLeft == todayDate) {
                                alertBlock = '<span class="dueSoon">Due today</span>';
                            } else {
                                var daysLeft = (timeLeft - todayDate)/86400000;
                                if ( daysLeft < 8 ){
                                    alertBlock = '<span class="dueSoon">'+daysLeft+' days left</span>';
                                }


                            }
                        }
                    }
					if(fine.DueDate === "Refer to notice"){
						alertBlock = '<span>Refer to notice</span>';
						dueDate = "";
					}


					var buttonsHtml = '</span><a href="/api/sitecore/FineDetails/OffencePhotoFile?obligationNumber='+fine.Index+'" data-id="'+fine.Index+'" target="_blank" id="OffenceImageOutstandingFineList" class="btn threeBtns btn-outline OffenceImageFineList"'+ (fine.HasImage ? "" : "style='display:none'" ) +'>Photo</a><a href="'+section.FinesDetailsUrl+'?obligation='+fine.Index+'" class="btn threeBtns btn-outline">Details</a>';

					if(fine.OnHold)
					{
						buttonsHtml += '<span href="#" class="btn threeBtns disable">On hold</span>';
					}
					else
					{

						buttonsHtml += '<form action="' + section.PayYourFineUrl + '" method="post" style="display:inline">' +
									        '<input type="hidden" name="Identifier" value="' + fine.ObligationNumber + '">' +
									        '<input type="hidden" name="currentPage" value="' + window.location.href + '">' +
									        '<button type="submit" class="btn threeBtns btn-colored white">Pay</button>' +
									    '</form>';
					}

					var fineStateInfo =_getIconAndFineStateText2(fine.FinesStage);

					var htmlToInsert = '<li style="'+isHidden+'">'+
											'<a href="javascript:void(0)" class="head">'+
												'<span>'+ fine.ObligationNumber + '</span>'+
												'<span class="icon-accordion-toggle" href="javascript:void(0)" title="Expand and close"><span class="sr-only"> Open / Close </span></span>' +
											'</a>'+

					                      '<div class="body"><table>'+
					                          '<tbody>'+
					                          '<tr>'+
					                            '<td class="outstandFirstChild"><label> Fine stage </label><span class="'+fineStateInfo.icon+'">'+fineStateInfo.state+'</span></td>'+
					                            '<td class="outstandSecChild"><label> Amount due </label><span class="bold">$'+fine.AmountDue+'</span></td>'+
					                            '<td class="outstandThirdChild"><label> Due date </label>' + alertBlock + ' ' + dueDate + '</td>'+
					                            '<td class="outstandFourChild">'+ buttonsHtml + '</td>'+
					                          '</tr>'+
					                          '</tbody>'+
					                        '</table>'+
					                      '</div>'+
					                    '</li>';

					$('#OutstandingFineList').append(htmlToInsert);
				}
					var addLeftRightBorder = " ";	
					if(section.WarrantCosts > 0){	
						addLeftRightBorder = " warrantNoteAddBorder";	
						var warrantCostRow = 	
														'<div class="warrantCost"><table>'+	
																'<tbody>'+	
																'<tr>'+	
																'<td><span><strong>Outstanding warrant costs not on a payment agreement</strong><br /> You have outstanding warrant costs that are not on a payment agreement. We are unable to process the listed warrant cost payments online. Please contact our offices on 1800 111 222 between 9am-5pm Monday to Friday to discuss your payment options.</span></td>'+	
																'<td><strong> $'+ Number(section.WarrantCosts).toFixed(2) +'</strong></td>'+	
																'<td><a href="javascript:void(0)" id="help-whatAreWarrantCost" > <span class="icon-question-warrantOutstanding" style="padding-right: 8px" title="Warrant costs include expenses incurred in engaging a contactor and/or agent in order to remove or sell property. The sheriff may recover all costs and expenses that are incurred for lawful activity under a warrant">What are warrant costs?</span></a></td>'+	
																'</tr>'+	
																'</tbody>'+	
															'</table>'+	
														'</div>';	
						$('#outstandingFineContent').after(warrantCostRow);	
					} else {	
							
						$("#ShowAllOutstanding").addClass('warrantNoteAddBorder');	
						if(!showAllFinesLink)
							$("#outstandingFineContent").css("border-bottom", "0px");	
						$("#OutstandingFineList li:last-child").css("border-bottom", "1px solid #ddd");	
							
					}	
					var showAllOutstandingFines = '<div class="warrantNote'+addLeftRightBorder + '"id="ShowAllOutstanding" style="'+ showAllFinesLink +'"><a href="javascript:void(0)" class="ShowAllFines" data-content-hidden="true">Show all <span class="bold TotalFines">'+ section.Obligations.length +'</span><span class="fineType"> outstanding fines</span></a></div>';	
					
					if(showAllFinesLink && $(".warrantNote").length < 1)
						$('#outstandingFineContent').after(showAllOutstandingFines);
			}

			function displayPaymentOrderFines(section){
				$('#PaymentOrderFineSummary').html(section.SummaryText);
				$('#PaymentOrderFineList').html('');


				var fineIcon = "";
				var fineState = "";

				if(section.Obligations.length == 0) {
                    $('#ShowAllOnPaymentOrder').prev('.content-holder').hide();
                    $('#ShowAllOnPaymentOrder').prev('.content-holder').prev('.content-header').hide();
				}
				if(section.Obligations.length > 0)
				{
					$('#PayForPaymentOrderForm').show();
					$('#PayForPaymentOrderForm input[name="Identifier"]').val(section.Obligations[0].ObligationNumber);

					if(section.Obligations.length > 5)
					{
						$('#ShowAllOnPaymentOrder').show();
						$('#ShowAllOnPaymentOrder .TotalFines').html(section.Obligations.length);
					}
				}

				for(var i = 0; i < section.Obligations.length; i++)
				{
					var isHidden = "";

					if(i > 4)
					{
						isHidden = "display:none";
					}

					var fine = section.Obligations[i];

					var fineStateInfo =_getIconAndFineStateText2(fine.FinesStage);


					var htmlToInsert = '<li style="'+isHidden+'">'+
											'<a href="javascript:void(0)" class="head">'+
												'<span>'+ fine.ObligationNumber + '<span>'+
											'</a>'+
					                      '<div class="body">'+
					                        '<table>'+
					                          '<tbody>'+
					                          '<tr>'+
					                            '<td><label> Fine stage </label><span class="'+fineStateInfo.icon+'">'+fineStateInfo.state+'</span></td>'+
					                            '<td><label> Amount </label><span class="bold">$'+fine.TotalFineAmount+'</span></td>'+
					                            '<td></td>'+
					                            '<td></span><a href="'+section.FinesDetailsUrl+'?obligation='+fine.Index+'" class="btn btn-outline">View</a>'+
					                            '</td>'+
					                          '</tr>'+
					                          '</tbody>'+
					                        '</table>'+
					                      '</div>'+
					                    '</li>';


					$('#PaymentOrderFineList').append(htmlToInsert);
				}
			}

			function displayPaymentPlanFines(section){
				$('#PaymentPlanFinesSummary').html(section.SummaryText);
				$('#PaymentPlanFineList').html('');

				var fineIcon = "";
				var fineState = "";

                if(section.Obligations.length == 0) {
                    $('#ShowAllOnPaymentPlan').prev('.content-holder').hide();
                    $('#ShowAllOnPaymentPlan').prev('.content-holder').prev('.content-header').hide();
                }

				if(section.Obligations.length > 0)
				{
					$('#PayForPaymentPlanForm').show();
					$('#PayForPaymentPlanForm input[name="Identifier"]').val(section.Obligations[0].ObligationNumber);

					if(section.Obligations.length > 5)
					{
						$('#ShowAllOnPaymentPlan').show();
						$('#ShowAllOnPaymentPlan .TotalFines').html(section.Obligations.length);
					}
				}

				for(var i = 0; i < section.Obligations.length; i++)
				{
					var isHidden = "";

					if(i > 4)
					{
						isHidden = "display:none";
					}

					var fine = section.Obligations[i];

					var fineStateInfo =_getIconAndFineStateText2(fine.FinesStage);

					var htmlToInsert = '<li style="'+isHidden+'">'+
											'<a href="javascript:void(0)" class="head">'+
												'<span>'+ fine.ObligationNumber + '<span>'+
											'</a>'+
					                      '<div class="body">'+
					                        '<table>'+
					                          '<tbody>'+
					                          '<tr>'+
					                            '<td><label> Fine stage </label><span class="'+fineStateInfo.icon+'">'+fineStateInfo.state+'</span></td>'+
					                            '<td><label> Amount </label><span class="bold">$'+fine.TotalFineAmount+'</span></td>'+
					                            '<td></td>'+
					                            '<td></span><a href="'+section.FinesDetailsUrl+'?obligation='+fine.Index+'" class="btn btn-outline">View</a>'+
					                            '</td>'+
					                          '</tr>'+
					                          '</tbody>'+
					                        '</table>'+
					                      '</div>'+
					                    '</li>';

					$('#PaymentPlanFineList').append(htmlToInsert);
				}
			}

			function displayClosedFines(section){
				var fineIcon = "";
				var fineState = "";

				$('#ClosedFinesList').html('');

				if(section.Obligations.length > 4)
				{
					$('#ShowAllClosed').show();
					$('#ShowAllClosed .TotalFines').html(section.Obligations.length);
				}

				for(var i = 0; i < section.Obligations.length; i++)
				{

					var isHidden = "";

					if(i > 4)
					{
						isHidden = "display:none";
					}

					var fine = section.Obligations[i];

					var fineStateInfo =_getIconAndFineStateText2(fine.FinesStage);
					var amountPaidCol = '';

					if(fine.AmountPaid != null && fine.AmountPaid != '0.00')
					{
						amountPaidCol = '<span class="bold">AMOUNT PAID</span><span class="amount">$'+fine.AmountPaid+'</span>';
					}
					var htmlToInsert = '<li style="'+isHidden+'">'+
											'<a href="javascript:void(0)" class="head">'+
												'<span>'+ fine.ObligationNumber + '<span>'+
											'</a>'+
					                      '<div class="body">'+
					                        '<table>'+
					                          '<tbody><tr>'+
					                            '<td></td>'+
					                            '<td></td>'+
					                            '<td></td>'+
					                            '<td class="right"><a href="/api/sitecore/FineDetails/OffencePhotoFile?obligationNumber='+fine.Index+'" target="_blank" id="OffenceImageClosedFineList" class="btn btn-outline OffenceImageClosedFineList"'+ (fine.HasImage ?  "" : "style='display:none'") +'>Photo</a><a href="'+section.FinesDetailsUrl+'?obligation='+fine.Index+'" class="btn btn-outline">Details</a></td>'+
					                          '</tr>'+
					                          '</tbody></table>'+
					                      '</div>'+
					                    '</li>';

					$('#ClosedFinesList').append(htmlToInsert);
				}
			}

			var displayPaymentArrangements = function _displayPaymentArrangements(section) {
				var $wrapper = $('.wrapper.fines');
				$.each(section, function (index, value) {
					$wrapper.append('\n\t\t\t\t\t\t<div class="content-header">\n\t\t\t\t\t\t\t<h4 class="payment-arrangement-header">Fines on payment arrangement ' + index + '</h4> \n\t\t\t\t\t\t\t<div class="upcoming-payment-due-date-mobile">\n\t\t\t\t\t\t\t\t<span id="paymentArrangementDueDateIconMobile" class="icon-clock icon-clock-upcoming-payment-mobile"></span>\n\t\t\t\t\t\t\t\t<span class="payment-arrangement-due-date-mobile" id = "paymentArrangementDueDateMobile"></span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<a id="yourFinesViewPaymentsButton' + index + '" + href="' + value.PaymentArrangementsUrl + '" class ="btn btn-colored white upcoming-payment-button-weight upcoming-payment-margin">Make a payment or view upcoming</a>\n\t\t\t\t\t\t\t<a  id="yourFinesSmsReminderButtonMobile' + index + '" + href="' + value.PaymentArrangementsUrl + '" class ="btn btn-outline sms-payment-reminder-mobile">\n\t\t\t\t\t\t\t\t<label id="paymentArrangementSmsNotificationButtonMobile">SMS placeholder</label>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div> \n\t\t\t\t\t\t<div class="content-header upcoming-payment-message-section">\n\t\t\t\t\t\t\t<span id = "paymentArrangementDueDateIcon" class="icon-clock icon-clock-upcoming-payment"></span>\n\t\t\t\t\t\t\t<span id = "paymentArrangementDueDate"></span>\n\t\t\t\t\t\t\t<a id="yourFinesSmsReminderButton' + index + '" + href="' + value.PaymentArrangementsUrl + '" class ="btn btn-outline sms-payment-reminder">\n\t\t\t\t\t\t\t\t<label id="paymentArrangementSmsNotificationButton">SMS placeholder</label>\n\t\t\t\t\t\t\t</a>           \n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="content-holder arrangement-holder">\n\t\t\t\t\t\t    <table class="fines-heading">\n\t\t\t\t\t\t        <tbody>\n\t\t\t\t\t\t            <tr id="payment-arrangement-table-' + index + '" data-index="' + index + '">\n\t\t\t\t\t\t                <td data-info="Obligation Number" class="fines-list-sort-button" data-order="asc" data-property="ObligationNumber" tabindex="0">OBLIGATION NUMBER <i class="icon-sort-no-arrow"></i></td>\n\t\t\t\t\t\t                <td data-info="Fine Stage" class="fines-list-sort-button" data-order="asc" data-property="FinesStage" tabindex="0">FINE STAGE <i class="icon-sort-no-arrow"></i></td>\n\t\t\t\t\t\t                <td data-info="Total Fine Amount" class="fines-list-sort-button" data-order="asc" data-property="TotalFineAmountDecimal" tabindex="0">TOTAL FINE AMOUNT <i class="icon-sort-no-arrow"></i></td>\n\t\t\t\t\t\t                <td data-info="Amount Outstanding" class="fines-list-sort-button" data-order="asc" data-property="AmountDueDecimal" tabindex="0">AMOUNT OUTSTANDING <i class="icon-sort-no-arrow your-fines-sort-margin"></i></td>\n\t\t\t\t\t\t                <td></td>\n\t\t\t\t\t\t            </tr>\n\t\t\t\t\t\t        </tbody>\n\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t<div id="payment-arrangement-table-' + index + '" data-table="payment-arrangement-table-' + index + '" class="fines-list-sort-mobile" data-index="' + index + '">\n\t\t\t\t\t\t\t\t<div class="fines-list-sort-order-information">\n\t\t\t\t\t\t\t\t\t<div class="sort-order-info-item">\n\t\t\t\t\t\t\t\t\t\t<p class="order-data-text-information"><i class="icon-sort-no-arrow"></i><b>Unordered</b></p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="sort-order-info-item no-print">\n\t\t\t\t\t\t\t\t\t\t<button class="btn btn-outline fines-list-sort-info-btn">Change Order</button>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="fines-list-sort-slide">\n\t\t\t\t\t\t\t\t\t<div class="fine-list-sort-order">\n\t\t\t\t\t\t\t\t\t\t<div class="fine-list-sort-order-item">\n\t\t\t\t\t\t\t\t\t\t\t<h6>ORDER</h6>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="fine-list-sort-order-item">\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t<button class="btn btn-outline fines-list-sort-order-btn" data-order="asc"><i class="icon-sort-arrow-flip sort-order-info-item"> </i> Ascending</button>\n\t\t\t\t\t\t\t\t\t\t\t<button class="btn btn-outline fines-list-sort-order-btn" data-order="desc"><i class="icon-sort-arrow sort-order-info-item"> </i> Descending</button>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="fine-list-sort-data">\n\t\t\t\t\t\t\t\t\t\t<div class="fine-list-sort-data-item">\n\t\t\t\t\t\t\t\t\t\t\t<h6>BY </h6>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="fine-list-sort-data-item">\n\t\t\t\t\t\t\t\t\t\t\t<div class="row">\n\t\t\t\t\t\t\t\t\t\t\t\t<button data-info="Obligation Number" class="btn btn-outline fines-list-sort-data-btn" data-property="ObligationNumber">Obligation #N</button>\n\t\t\t\t\t\t\t\t\t\t\t\t<button data-info="Fine Stage" class="btn btn-outline fines-list-sort-data-btn" data-property="FinesStage">Fine Stage</button>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="row">\n\t\t\t\t\t\t\t\t\t\t\t\t<button data-info="Total Amount" class="btn btn-outline fines-list-sort-data-btn" data-property="TotalFineAmountDecimal">Total Amount</button>\n\t\t\t\t\t\t\t\t\t\t\t\t<button data-info="Total Fine Amount" class="btn btn-outline fines-list-sort-data-btn" data-property="AmountDueDecimal">Amount Outstanding</button>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t' + _getObligationsHTML(value.Obligations, value.FinesDetailsUrl, value.PayYourFineUrl) + '\n\t\t\t\t\t\t</div>\n                  \t');
					document.getElementById('paymentArrangementSmsNotificationButtonMobile').id = 'paymentArrangementSmsNotificationButtonMobile_' + index;
					document.getElementById('paymentArrangementDueDateIconMobile').id = 'paymentArrangementDueDateIconMobile_' + index;
					document.getElementById('paymentArrangementDueDateMobile').id = 'paymentArrangementDueDateMobile_' + index;
					document.getElementById('paymentArrangementSmsNotificationButton').id = 'paymentArrangementSmsNotificationButton_' + index;
					document.getElementById('paymentArrangementDueDateIcon').id = 'paymentArrangementDueDateIcon_' + index;
					document.getElementById('paymentArrangementDueDate').id = 'paymentArrangementDueDate_' + index;
	
					_getSmsSetupButtonText3(index);
					_getNextUpcomingPaymentDate3(index);
	
					if (value.Obligations.length > 5) {
						$('.arrangement-holder ul.fines-table > li:nth-child(5)').css('border-bottom', 'none');
						$wrapper.append('\n\t\t\t\t\t\t\t<div class="note showall">\n\t\t\t\t\t\t\t\t<a href="javascript:void(0)" class="ShowAllFines" data-content-hidden="true">Show all <span class="bold TotalFines">' + value.Obligations.length + '</span><span class="fineType"> fines that make up this payment arrangement</span></a>\n\t\t\t\t\t\t\t</div>\n                  \t\t');
					}
					if(value.WarrantCosts > 0){	
						var warrantCostRow = `<div class="content-holder" style="border-bottom:none">	
						<ul class="fines-table">	
						<li>	
							<div class="warrantCostPA">	
								  <table>	
									  <tbody><tr>	
										  <td>
										  <span><strong>Outstanding warrant costs included in this payment arrangement</strong></span></td>	
										  <td><span class="bold">$${Number(value.WarrantCosts).toFixed(2)}</span></td>
										  <td><a href="javascript:void(0)" class="help-whatAreWarrantCostPA" ><span class="icon-question-warrant" title="Warrant costs include expenses incurred in engaging a contactor and/or agent in order to remove or sell property. The sheriff may recover all costs and expenses that are incurred for lawful activity under a warrant.">What are warrant costs?</span></a></td>	
									  </tr>	
								  </tbody></table>	
							</div>	
						  </li>	
						</ul>	
							
						</div>	
						`;	
						$wrapper.append(warrantCostRow);	
					}
					var TotalAmountDue = Number(value.FormattedTotalAmountDue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
					$wrapper.append('<div class="content-holder" style="border-bottom:none;border-top:none">\n\t\t\t\t\t  <div class="content-header yourtotal arrangement-total"> \n\t\t\t\t\t  <ul class="fines-table">\n\t\t\t\t\t  <li>\n\t\t\t\t\t\t\t<div href="javascript:void(0)" class="title">\n\t\t\t\t\t\t\t<h4 class="arrangement-title">Total amount outstanding</h4>\n\t\t\t\t\t\t\t<span>on payment arrangement ' + index + '</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="data">\n\t\t\t\t\t\t\t\t<table>\n\t\t\t\t\t\t\t\t\t<tbody><tr>\n\t\t\t\t\t\t\t\t\t\t<td></td>\n\t\t\t\t\t\t\t\t\t\t<td><label> Amount Due </label><span class="bold">$' + TotalAmountDue + '</span></td>\n\t\t\t\t\t\t\t\t\t\t<td></td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t</tbody></table>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t  </div>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t  </ul>\n\t\t\t\t\t  \n\t\t\t\t\t  </div>\n\t\t\t\t\t  ');
					
					$('#yourFinesViewPaymentsButton' + index + '').hover(function () {
						localStorage.setItem('selectedPaymentArrangementNo', index);
					});
					$('#yourFinesSmsReminderButton' + index + '').click(function () {
						localStorage.setItem('selectedPaymentArrangementNo', index);
					});
					$('#yourFinesSmsReminderButtonMobile' + index + '').click(function () {
						localStorage.setItem('selectedPaymentArrangementNo', index);
					});
				});
			};
	
			var _getSmsSetupButtonText3 = function _getSmsSetupButtonText(index) {
				//review API return containing data on mobile number and SMS reminder setup status before appending respective string to be displayed in the SMS setup/modification button to its corresponding element
	
				var controllerUrl = "/api/sitecore/UpcomingPaymentArrangement";
				var getPhoneNumberUrl = "/GetPhoneNumber";
				var smsMessageText = void 0;
	
				$.ajax({
					method: "POST",
					url: window.location.origin + controllerUrl + getPhoneNumberUrl,
					success: function success(response) {
						if (response === true || !(response.IsEnabled === true)) {
							smsMessageText = "Setup an SMS payment reminder";
						} else {
							smsMessageText = "Modify an SMS payment reminder";
						}
						var smsNotificationButtonStr = 'paymentArrangementSmsNotificationButton_' + index;
						var smsNotificationButtonMobileStr = 'paymentArrangementSmsNotificationButtonMobile_' + index;
	
						document.getElementById(smsNotificationButtonStr).innerHTML = smsMessageText;
						document.getElementById(smsNotificationButtonMobileStr).innerHTML = smsMessageText;
					}
				});
			};
	
			var _getNextUpcomingPaymentDate3 = function _getNextUpcomingPaymentDate(index) {
				//get next upcoming due date for payment for a given obligation number and display a corresponding message for an overdue or upcoming payment
	
				var upcomingDueDates = [];
				var nextUpcomingPaymentDate = "";
				var nextUpcomingPaymentDateMobile = "";
				var controllerUrl = "/api/sitecore/UpcomingPaymentArrangement";
				var upcomingPaymentDataUrl = "/GetUpcomingPayments";
				var upcomingPayments = [];
	
				function findFirstOccurrence(arrangement) {
					return arrangement.ArrangementNo === index;
				}
	
				$.ajax({
					method: "POST",
					url: window.location.origin + controllerUrl + upcomingPaymentDataUrl,
					success: function success(response) {
						var paymentArrangements = response;
						//var firstOccurrence = upcomingPayments.find(x => x.ArrangementNo === index);
						var firstOccurrence = paymentArrangements.find(findFirstOccurrence);
						if (firstOccurrence !== undefined) {
							var firstOccurrenceDate = firstOccurrence.DuedateString;
	
							var todaysDate = new Date();
							var dd = String(todaysDate.getDate()).padStart(2, '0');
							var mm = String(todaysDate.getMonth() + 1).padStart(2, '0');
							var yyyy = todaysDate.getFullYear();
							todaysDate = dd + '/' + mm + '/' + yyyy;
	
							// for (var _key in upcomingDueDates) {
	
							upcomingDueDates.push(todaysDate);
							upcomingDueDates.push(firstOccurrenceDate);
	
							upcomingDueDates.sort(function (upcomingDueDate1, upcomingDueDate2) {
								var firstDate = upcomingDueDate1.split('/').reverse().join(),
									secondDate = upcomingDueDate2.split('/').reverse().join();
								return firstDate < secondDate ? -1 : firstDate > secondDate ? 1 : 0;
							});
	
							if (upcomingDueDates[0] != todaysDate) {
								nextUpcomingPaymentDate = "You have an overdue payment";
								nextUpcomingPaymentDateMobile = "You have an overdue payment";
							} else {
								nextUpcomingPaymentDate = "Your next payment is due " + upcomingDueDates[1];
								nextUpcomingPaymentDateMobile = "Next payment due " + upcomingDueDates[1];
							}
	
							var paymentArrangementDueDateStr = 'paymentArrangementDueDate_' + index;
							var paymentArrangementDueDateMobileStr = 'paymentArrangementDueDateMobile_' + index;
	
							document.getElementById(paymentArrangementDueDateStr).innerHTML = nextUpcomingPaymentDate;
							document.getElementById(paymentArrangementDueDateMobileStr).innerHTML = nextUpcomingPaymentDateMobile;
						} else {
							var paymentArrangementDueDateIcon = 'paymentArrangementDueDateIcon_' + index;
							var paymentArrangementDueDateIconMobile = 'paymentArrangementDueDateIconMobile_' + index;
							document.getElementById(paymentArrangementDueDateIcon).style.visibility = 'hidden';
							document.getElementById(paymentArrangementDueDateIconMobile).style.visibility = 'hidden';
						}
					}
				});
			};
	
			var _getObligationsHTML = function _getObligationsHTML(obligations, FinesDetailsUrl, PayYourFineUrl) {
				var html = '<ul class="fines-table">';
				$.each(obligations, function (index, value) {
					var fineStateInfo = _getIconAndFineStateText2(value.FinesStage);
					html += '\n\t\t\t\t\t\t<li ' + (index > 4 ? 'style="display:none"' : '') + '>\n\t\t\t\t\t\t\t<a href="javascript:void(0)" class="head">\n\t\t\t\t\t\t\t\t<span>' + value.ObligationNumber + '</span>\n\t\t\t\t\t\t\t\t<span class="icon-accordion-toggle" href="javascript:void(0)" title="Expand and close">\n\t\t\t\t\t\t\t\t\t<span class="sr-only"> Open / Close </span>\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t<div class="body">\n\t\t\t\t\t\t\t\t<table>\n\t\t\t\t\t\t\t\t\t<tbody><tr>\n\t\t\t\t\t\t\t\t\t\t<td><label> Fine stage </label><span class="' + fineStateInfo.icon + '">' + fineStateInfo.state + '</span></td>\n\t\t\t\t\t\t\t\t\t\t<td><label> Total amount </label><span class="bold">$' + value.TotalFineAmount + '</span></td>\n\t\t\t\t\t\t\t\t\t\t<td><label> Amount outstanding </label><span class="bold">$' + value.AmountDue + '</span></td>\n\t\t\t\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t\t\t\t<a href="' + FinesDetailsUrl + '?obligation=' + value.Index + '" class="btn btn-outline">View</a>\n\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t</tbody></table>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t';
				});
	
				html += '</ul>';
	
				return html;
			};

			function _getIconAndFineStateText2(fineStage)
			{
				var fineState = '';
				var fineIcon = '';
				switch(fineStage)
				{
					case 'Infringement':
						fineState = 'Infringement Notice';
						fineIcon = 'icon-doc';
				        break;
			        case 'PenaltyReminder':
						fineState = 'Penalty Reminder';
						fineIcon = 'icon-clock';
				        break;
				    case 'NoticeOfFinalDemand':
						fineState = 'Notice of Final Demand';
						fineIcon = 'icon-alert';
				        break;
				    case 'EnforcementOrder':
						fineState = 'Enforcement Order';
						fineIcon = 'icon-gavel';
				        break;
			        case 'EnforcementWarrant':
						fineState = 'Enforcement Warrant';
						fineIcon = 'icon-badge';
				        break;
			        case 'Warrant':
						fineState = 'Warrant';
						fineIcon = 'icon-badge';
				        break;
			        case 'ReferredCourtFine':
						fineState = 'Court fine collection statement';
						fineIcon = 'icon-court';
				        break;
			        case 'EnforcementHearingOrderStatement':
						fineState = 'Enforcement Hearing Order Statement';
						fineIcon = 'icon-badge';
				        break;						
				    default:
						fineState = '';
						fineIcon = '';
				    	break;
				}

				return {
						icon: fineIcon,
					    state: fineState
						};
			}
		}
	}
}
